import React from "react";
import { TranslateText } from "../../../../../utils/translation";
import { Button } from "antd";
const CustomButton = ({ active, setActive }) => {
  return (
    <div className="flex button-group gap-1 rounded-lg w-[4.75rem] h-[2.5rem]">
      <Button
        onClick={() => setActive("AM")}
        value="AM"
        className={`${
          active === "AM"
            ? "border border-[#007FFF]  rounded-lg text-[#007FFF]"
            : "text-[#808080]"
        } bg-[#F0F3F7] rounded-0   w-[2.7rem] h-[99%] `}
      >
        <TranslateText textKey={"am"} namespace="common" />
      </Button>

      <Button
        onClick={() => setActive("PM")}
        value="PM"
        className={`${
          active === "PM"
            ? "border border-[#007FFF]  rounded-lg text-[#007FFF]"
            : "text-[#808080]"
        } bg-[#F0F3F7] rounded-0  w-[2.7rem] h-[99%]`}
      >
        <TranslateText textKey={"pm"} namespace="common" />
      </Button>
    </div>
  );
};

export default CustomButton;
